import React from 'react';

export const FPEntail = [
	{
		id: 1,
		type: 'multicolumn',
		paragraphs: [
			{
				id: 11,
				paragraph: [
					<p>
						Financial planning, as the name suggests, refers to preparing a plan
						or strategy to achieve personal financial goals. Planning helps in
						achieving monetary goals and objectives faster, along with preparing
						oneself for any shocks and surprises. One can create a financial
						plan individually or with the help of a financial planning service.
						In either case, it starts with analysing your current financial
						status, listing down future financial goals, and then developing an
						action plan to achieve those goals.
					</p>,
				],
			},
			{
				id: 12,
				paragraph: [
					<p>
						Often, financial goals are either purchasing an asset, planning for
						big expenditures like travel or children’s education, or for leading
						a relaxed life post retirement. To achieve any of these goals, the
						most crucial aspect is the approach one takes towards investments.
						In most scenarios, savings and investments are done with whatever
						surplus is left after all expenses. However, financial planning for
						individuals helps them in changing this approach, leading to an
						investment-first lifestyle.
					</p>,
				],
			},
		],
	},
];
